export const SET_SHOW_BULK_ENTRY_MODAL = 'SET_SHOW_BULK_ENTRY_MODAL';

export const ADD_TIME_ENTRY_BULK = 'ADD_TIME_ENTRY_BULK';
export const ADD_TIME_ENTRY_BULK_SUCCESS = 'ADD_TIME_ENTRY_BULK_SUCCESS';
export const ADD_TIME_ENTRY_BULK_ERROR = 'ADD_TIME_ENTRY_BULK_ERROR';
